// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router';
// import regarding from '@/regarding/regarding.vue'; // 导入组件
// import payPage from '@/pay/payPage.vue';
// import payment from '@/payment/payment.vue';
// import homePage from '@/home/homePage.vue';
// import AppVue from '@/App.vue';
// import index1 from '@/soliv/index1.vue';
// import index2 from '@/soliv/index2.vue';
// import index3 from '@/soliv/index3.vue';
// import index4 from '@/soliv/index4.vue';



const routes = [
  {
    path: '/',
    name: '/',
    component: () => import("@/App.vue"),
    children: [
      {
        path: '/regarding',
        name: 'regarding',
        component: () => import("@/regarding/regarding.vue")
      },
      {
        path: '/payment',
        name: 'payment',
        component:() => import("@/payment/payment.vue"),
      },
       {
        path: '/payPage',
        name: 'payPage',
        component:() => import("@/pay/payPage.vue"),
      },
       {
        path: '/index1',
        name: 'index1',
        component:() => import("@/soliv/index1.vue"),
      },
       {
        path: '/index2',
        name: 'index2',
        component:() => import("@/soliv/index2.vue"),
      },
       {
        path: '/index3',
        name: 'index3',
        component:() => import("@/soliv/index3.vue"),
      },
       {
        path: '/index4',
        name: 'index4',
        component:() => import("@/soliv/index4.vue"),
      },
    ]
  },

  // 其他路由...
];

const router = createRouter({
  history: createWebHistory(), // 使用HTML5历史模式
  routes,
});

export default router;